<script>
  import WorkPage from '$lib/pages/WorkPage.svelte';
</script>

<WorkPage />

